const SESSION_CONTEXT_TIMEOUT_MS = 15_000;

export async function postSessionContext(): Promise<Response | null> {
  const controller = new AbortController();
  const timeoutId = globalThis.setTimeout(() => controller.abort(), SESSION_CONTEXT_TIMEOUT_MS);

  try {
    return await fetch("/api/auth/session-context", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal: controller.signal,
    });
  } catch (error) {
    console.warn(
      "[auth] session-context request failed:",
      error instanceof Error ? error.message : String(error),
    );
    return null;
  } finally {
    globalThis.clearTimeout(timeoutId);
  }
}
